import {
    BillingProvider,
    DocumentPreviewProvider,
    DocumentProvider,
    DossierPrescriberProvider,
    DossierValidatorProvider,
    SelectedDossierProvider,
    SelectGreffeModal,
    useDefaultContextActions,
} from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { DetailDossierHeader, DossierBody } from '../../components';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    return (
        <SelectedDossierProvider>
            <DossierValidatorProvider>
                <DocumentProvider idDossiers={[idDossier] as unknown as number[]}>
                    <BillingProvider origine="B2D">
                        <DocumentPreviewProvider>
                            <Container maxWidth="lg">
                                <DossierPrescriberProvider>
                                    <DetailDossierHeader />
                                    <DossierBody />
                                </DossierPrescriberProvider>
                            </Container>
                        </DocumentPreviewProvider>
                    </BillingProvider>
                </DocumentProvider>
            </DossierValidatorProvider>
            <SelectGreffeModal />
        </SelectedDossierProvider>
    );
};

export default DetailDossier;
